import React from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import {connect} from "react-redux";
import {PROGRAM_ADN} from "../config/constants";

const FormNav = (props) => props.programId === PROGRAM_ADN ? (
  <Nav bsStyle="pills" justified activeKey={props.step} onSelect={props.onStepChange}>
    <NavItem eventKey={1}>Basic Information</NavItem>
    <NavItem eventKey={2}>Education Information</NavItem>
    <NavItem eventKey={3}>Professional Information</NavItem>
    <NavItem eventKey={4}>Other Information</NavItem>
    <NavItem eventKey={5}>Form Summary</NavItem>
  </Nav>
) : (
  <Nav bsStyle="pills" justified activeKey={props.step} onSelect={props.onStepChange}>
    <NavItem eventKey={1}>Basic Information</NavItem>
    <NavItem eventKey={2}>Education Information</NavItem>
    <NavItem eventKey={3}>PT Requirements</NavItem>
    <NavItem eventKey={4}>Form Summary</NavItem>
  </Nav>
);

function mapStateToProps(state) {
    const { step } = state.form;
    const { programId } = state.appInfo.application;
    return {
        programId,
        step
    }
}

export default connect(mapStateToProps)(FormNav);